import React from 'react';
import useReveal from '../hooks/use-reveal';

const CARDS = [
  {
    num: '01',
    title: 'Name it',
    body:
      "When we put words to what's inside — even privately — the nervous system starts to regulate. The thought loses some of its power.",
  },
  {
    num: '02',
    title: 'Share it',
    body:
      'When we share it — even with strangers — something shifts. The mask loosens. The voice gets a little louder. The gap closes slightly.',
  },
  {
    num: '03',
    title: 'Repeat it',
    body:
      '30 days of this creates a new pattern. Not a performance. Not a personal brand. Just a more honest version of how you show up.',
  },
];

const WhySharingMatters = () => {
  const head = useReveal();
  const cards = useReveal();

  return (
    <div
      data-testid="why-sharing-section"
      style={{
        background: 'var(--yup-accent)',
        padding: '100px 24px',
      }}
    >
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <div ref={head.ref} className={`reveal ${head.visible ? 'visible' : ''}`}>
          <div
            className="yup-eyebrow"
            style={{ color: 'rgba(249, 245, 239, 0.5)', marginBottom: '20px' }}
          >
            Why sharing matters
          </div>
          <h2
            className="font-serif"
            style={{
              fontSize: 'clamp(28px, 5vw, 48px)',
              fontWeight: 300,
              lineHeight: 1.2,
              color: 'var(--yup-bg)',
              letterSpacing: '-0.5px',
            }}
          >
            The science is simple.<br />
            <em style={{ fontStyle: 'italic', color: 'rgba(249, 245, 239, 0.7)' }}>
              The experience is profound.
            </em>
          </h2>
        </div>

        <div
          ref={cards.ref}
          className={`reveal ${cards.visible ? 'visible' : ''}`}
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: '2px',
            marginTop: '48px',
          }}
        >
          {CARDS.map((c) => (
            <div
              key={c.num}
              data-testid={`voice-card-${c.num}`}
              style={{
                background: 'rgba(255, 255, 255, 0.06)',
                padding: '32px 28px',
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
              }}
            >
              <div
                className="font-serif"
                style={{
                  fontSize: '40px',
                  fontWeight: 300,
                  color: 'rgba(249, 245, 239, 0.2)',
                  lineHeight: 1,
                  marginBottom: '16px',
                }}
              >
                {c.num}
              </div>
              <div
                style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  color: 'var(--yup-bg)',
                  marginBottom: '10px',
                }}
              >
                {c.title}
              </div>
              <p
                style={{
                  fontSize: '13px',
                  color: 'rgba(249, 245, 239, 0.6)',
                  lineHeight: 1.7,
                }}
              >
                {c.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhySharingMatters;
